import { useGetBillingUnits } from '@dhl/mdp-api'

export const useBillingUnits = () => {
  const { data, isFetching } = useGetBillingUnits()
  return { billingUnits: data?.content ?? [], isLoading: isFetching }
}
